import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-olive-dark text-brand-beige">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <img
                src="https://storage.readdy-site.link/project_files/03fe7774-bd67-4ad6-ac29-0dc609d1d53b/78cdd123-162e-4d26-97db-569471a61e50_pearl-logo-2.png?v=7161e591673fd16c8665db95bc0f5e63"
                alt="Pearl Foods"
                className="h-12 w-auto object-contain"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
              <span className="font-serif text-brand-cream text-xl font-bold tracking-wide">Pearl Foods</span>
            </div>
            <p className="text-brand-beige/70 text-sm font-sans leading-relaxed mb-4">
              Handcrafted organic food products made with traditional methods. 
              Pure, non-processed, and free from chemicals.
            </p>
            <div className="flex items-center gap-2 text-brand-gold-light text-sm font-sans">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-map-pin-2-line"></i>
              </div>
              Islamabad, Pakistan
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-brand-gold text-lg mb-4">
              <a id="footer-quick-links">Quick Links</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Home', href: '/' },
                { label: 'All Products', href: '/products' },
                { label: 'About Us', href: '/about' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-brand-beige/70 hover:text-brand-gold text-sm font-sans transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="font-serif text-brand-gold text-lg mb-4">Collections</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Garam Masala', category: 'Garam Masala' },
                { label: 'Organic Flour', category: 'Organic Flour' },
                { label: 'Organic Oils', category: 'Organic Oils' },
                { label: 'Organic Seeds', category: 'Organic Seeds' },
                { label: 'Recipe Masalas', category: 'Recipe Masalas' },
                { label: 'Super Foods', category: 'Super Foods' },
                { label: 'Remedies', category: 'Remedies' },
                { label: 'Honey', category: 'Honey' },
              ].map((item) => (
                <li key={item.category}>
                  <Link
                    to={`/products?category=${encodeURIComponent(item.category)}`}
                    className="text-brand-beige/70 hover:text-brand-gold text-sm font-sans transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-brand-gold text-lg mb-4">Get in Touch</h4>
            <div className="space-y-4">
              <a
                href="https://wa.me/923445299984"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 bg-brand-olive/50 hover:bg-brand-olive/80 px-4 py-3 rounded-xl transition-all duration-200 cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-[#25D366] rounded-full flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-base"></i>
                </div>
                <div>
                  <p className="text-brand-cream text-sm font-medium font-sans">WhatsApp Us</p>
                  <p className="text-brand-beige/60 text-xs font-sans">+92 344 5299984</p>
                </div>
              </a>
              <div className="flex items-start gap-3 text-brand-beige/70 text-sm font-sans">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-brand-gold"></i>
                </div>
                <div>
                  <p className="text-brand-cream text-sm font-medium">Response Time</p>
                  <p className="text-xs mt-0.5">Usually within a few hours</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Brand Tagline Bar */}
      <div className="border-t border-brand-olive/60 py-6 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-4 text-xs text-brand-beige/50 font-sans">
            <span>© {currentYear} Pearl Foods</span>
            <span>•</span>
            <span>Islamabad, Pakistan</span>
          </div>
          <div className="flex items-center gap-5 text-xs text-brand-beige/50 font-sans">
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-leaf-line text-brand-gold/70"></i>
              </div>
              100% Organic
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-hand-heart-line text-brand-gold/70"></i>
              </div>
              Hand Made
            </span>
            <span className="flex items-center gap-1.5">
              <div className="w-3 h-3 flex items-center justify-center">
                <i className="ri-shield-check-line text-brand-gold/70"></i>
              </div>
              Chemical Free
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
